var _mask, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1634_3731",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    rx: 1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    rx: 1,
    stroke: "black",
    strokeWidth: 3.33333,
    mask: "url(#path-1-inside-1_1634_3731)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7771 11.7594H13.3327V7.31496C13.3327 6.90586 13.001 6.57422 12.5919 6.57422C12.1828 6.57422 11.8512 6.90586 11.8512 7.31496V11.7594H7.40676C6.99766 11.7594 6.66602 12.091 6.66602 12.5001C6.66602 12.9092 6.99766 13.2409 7.40676 13.2409H11.8512V17.6853C11.8512 18.0944 12.1828 18.4261 12.5919 18.4261C13.001 18.4261 13.3327 18.0944 13.3327 17.6853V13.2409H17.7771C18.1862 13.2409 18.5179 12.9092 18.5179 12.5001C18.5179 12.091 18.1862 11.7594 17.7771 11.7594Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plusIcon.d6eb9cd8ed7e2d3eb94b3b610385af38.svg";
export { ForwardRef as ReactComponent };